import * as React from 'react';
import { StyledEngineProvider } from '@mui/material/styles';
import AutoCompleteEnhance from './components/AutoCompleteEnhance';

function App() {
  return (
    <StyledEngineProvider injectFirst>
    <AutoCompleteEnhance />
  </StyledEngineProvider>
  );
}

export default App;
